<template>
  <div>
    <v-dialog v-model="confirmDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">
          <span style="color: #d60000">{{ $t('crudTiposAtendimento.messages.systemMessage') }}</span>
        </v-card-title>
        <v-card-text>
          <span style="color: #d60000">{{ this.mensagemdialog }}</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{
            this.messageDismissButton }}</v-btn>
          <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text" @click="deleteFromDatabase">{{
            this.messageConfirmButton }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <merus-data-table :headers="headers" :items="tiposAtendimento" :search="search" :loading="loadingtable"
      :loading-text="$t('crudTiposAtendimento.loading')" dense class="elevation-7"
      locale="pt" style="border-radius: 10px" :default-multi-sort="defaultSort"

 cod-tabela="TIPOSATENDIMENTO" @update:headers="headers = $event">
      <template v-slot:toolbar>
        <cadastro-toolbar :title="$t('crudAtendimentoConfig.tabs.tipos')" :token="token" :items="tiposAtendimento"
          csv-title="tipos_atendimento" @search="search = $event">
          <template v-slot:add>
            <v-dialog v-model="dialog" max-width="100%">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-toolbar dark color="primary" ref="myToolbar">
                  <v-btn icon dark @click="close">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn dark text @click="save">{{ $t('button.save') }}</v-btn>
                  </v-toolbar-items>
                </v-toolbar>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="formValidado">
                      <v-row style="padding-top: 10px;" justify="center">
                        <v-col cols="12" sm="6" md="4">
                          <v-select v-model="editedItem.id_familia_atendimento"
                            :items="familiasAtendimento"
                            item-text="nome_familia_atendimento"
                            item-value="id_familia_atendimento"
                            :label="$t('crudTiposAtendimento.form.fields.familia')"
                            :rules="[familiaRules]"
                            clearable></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-select v-model="editedItem.id_tipo_ticket"
                            :items="tiposTickets"
                            item-text="nome_tipo_ticket"
                            item-value="id_tipo_ticket"
                            :label="$t('crudTiposAtendimento.form.fields.tipoTicket')"
                            :rules="[tipoTicketRules]"
                            clearable></v-select>
                        </v-col>
                      </v-row>
                      <v-row style="padding-top: 10px;" justify="center">
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field v-model="editedItem.nome_tipo_atendimento"
                            :label="$t('crudTiposAtendimento.form.fields.nome')"
                            :rules="[nomeRules]"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-switch v-model="editedItem.ativo" class="ma-2"
                            :label="$t('crudTiposAtendimento.form.fields.ativo')"
                            color="primary"></v-switch>
                        </v-col>
                      </v-row>
                      <v-row style="padding-top: 10px;" justify="center">
                        <v-col cols="12" sm="6" md="2">
                          <v-switch v-model="editedItem.usa_veiculo" class="ma-2"
                            :label="$t('crudTiposAtendimento.form.fields.usaVeiculo')"
                            color="primary"></v-switch>
                        </v-col>
                        <v-col cols="12" sm="6" md="2">
                          <v-switch v-model="editedItem.usa_equipamento" class="ma-2"
                            :label="$t('crudTiposAtendimento.form.fields.usaEquipamento')"
                            @change="if (!editedItem.usa_equipamento) editedItem.equipamento_por_tipo = false"
                            color="primary"></v-switch>
                        </v-col>
                        <v-col cols="12" sm="6" md="2">
                          <v-switch v-model="editedItem.equipamento_por_tipo" class="ma-2"
                            :label="$t('crudTiposAtendimento.form.fields.equipamentoPorTipo')"
                            :disabled="!editedItem.usa_equipamento"
                            color="primary"></v-switch>
                        </v-col>
                        <v-col cols="12" sm="6" md="2">
                          <v-switch v-model="editedItem.usa_kit" class="ma-2"
                            :label="$t('crudTiposAtendimento.form.fields.usaKit')"
                            @change="if (!editedItem.usa_kit) editedItem.kit_por_tipo = false"
                            color="primary"></v-switch>
                        </v-col>
                        <v-col cols="12" sm="6" md="2">
                          <v-switch v-model="editedItem.kit_por_tipo" class="ma-2"
                            :label="$t('crudTiposAtendimento.form.fields.kitPorTipo')"
                            :disabled="!editedItem.usa_kit"
                            color="primary"></v-switch>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>
        </cadastro-toolbar>
      </template>
      <template v-slot:item.ativo="{ item }">
        <v-chip small :color="item.ativo === 1 || item.ativo === true ? 'green' : 'grey'" dark>
          {{ item.ativo === 1 || item.ativo === true ? $t('crudTiposAtendimento.activeYes') : $t('crudTiposAtendimento.activeNo') }}
        </v-chip>
      </template>
      <template v-slot:item.usa_veiculo="{ item }">
        <v-chip small :color="item.usa_veiculo === 1 || item.usa_veiculo === true ? 'green' : 'grey'" dark>
          {{ item.usa_veiculo === 1 || item.usa_veiculo === true ? $t('crudTiposAtendimento.activeYes') : $t('crudTiposAtendimento.activeNo') }}
        </v-chip>
      </template>
      <template v-slot:item.usa_equipamento="{ item }">
        <v-chip small :color="item.usa_equipamento === 1 || item.usa_equipamento === true ? 'green' : 'grey'" dark>
          {{ item.usa_equipamento === 1 || item.usa_equipamento === true ? $t('crudTiposAtendimento.activeYes') : $t('crudTiposAtendimento.activeNo') }}
        </v-chip>
      </template>
      <template v-slot:item.equipamento_por_tipo="{ item }">
        <v-chip small :color="(item.usa_equipamento && (item.equipamento_por_tipo === 1 || item.equipamento_por_tipo === true)) ? 'green' : 'grey'" dark>
          {{ (item.usa_equipamento && (item.equipamento_por_tipo === 1 || item.equipamento_por_tipo === true)) ? $t('crudTiposAtendimento.activeYes') : $t('crudTiposAtendimento.activeNo') }}
        </v-chip>
      </template>
      <template v-slot:item.usa_kit="{ item }">
        <v-chip small :color="item.usa_kit === 1 || item.usa_kit === true ? 'green' : 'grey'" dark>
          {{ item.usa_kit === 1 || item.usa_kit === true ? $t('crudTiposAtendimento.activeYes') : $t('crudTiposAtendimento.activeNo') }}
        </v-chip>
      </template>
      <template v-slot:item.kit_por_tipo="{ item }">
        <v-chip small :color="(item.usa_kit && (item.kit_por_tipo === 1 || item.kit_por_tipo === true)) ? 'green' : 'grey'" dark>
          {{ (item.usa_kit && (item.kit_por_tipo === 1 || item.kit_por_tipo === true)) ? $t('crudTiposAtendimento.activeYes') : $t('crudTiposAtendimento.activeNo') }}
        </v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="green" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon small class="mr-2" color="red" @click="deleteItem(item)">mdi-delete</v-icon>
      </template>
    </merus-data-table>
  </div>
</template>

<script>

import apiController from "@/utils/apiController";
import { validador } from "@/constants";
import EventBus from "../../utils/eventBus";
import MerusDataTable from '../Tables/MerusDataTable.vue';
import CadastroToolbar from '../Toolbars/CadastroToolbar.vue';

export default {
  components: {
    MerusDataTable,
    CadastroToolbar,
  },
  data: () => ({
    headers: [],
    user: null,
    token: null,
    showConfirmButton: true,
    formValidado: true,
    dialog: false,
    operacao: 0,
    confirmDialog: false,
    mensagemdialog: "",
    loadingtable: true,
    search: "",
    tiposAtendimento: [],
    familiasAtendimento: [],
    tiposTickets: [],
    editedIndex: -1,
    editedItem: {
      id_tipo_atendimento: null,
      id_familia_atendimento: null,
      id_tipo_ticket: null,
      nome_tipo_atendimento: null,
      ativo: true,
      usa_veiculo: false,
      usa_equipamento: false,
      equipamento_por_tipo: false,
      usa_kit: false,
      kit_por_tipo: false,
    },
    deletedItem: {
      id_tipo_atendimento: null,
      id_familia_atendimento: null,
      id_tipo_ticket: null,
      nome_tipo_atendimento: null,
      ativo: null,
      usa_veiculo: false,
      usa_equipamento: false,
      equipamento_por_tipo: false,
      usa_kit: false,
      kit_por_tipo: false,
    },
    defaultItem: {
      id_tipo_atendimento: null,
      id_familia_atendimento: null,
      id_tipo_ticket: null,
      nome_tipo_atendimento: null,
      ativo: true,
      usa_veiculo: false,
      usa_equipamento: false,
      equipamento_por_tipo: false,
      usa_kit: false,
      kit_por_tipo: false,
    },
  }),
  computed: {
    messageDismissButton() { return this.$t('button.dismiss'); },
    messageConfirmButton() { return this.$t('button.confirm'); },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t('crudTiposAtendimento.form.title.create')
        : this.$t('crudTiposAtendimento.form.title.edit');
    },
    defaultSort() {
      return [
        { value: 'nome_tipo_atendimento', options: { text: this.$t('system.labels.increasing'), value: 1 } }];
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.populaTiposAtendimento();
    this.populaFamiliasAtendimento();
    this.populaTiposTickets();
  },
  mounted() { },
  methods: {

    nomeRules() {
      if (!validador(this.editedItem.nome_tipo_atendimento, 1, 100, 1, 1)) {
        return this.$t('crudTiposAtendimento.form.validation.nameRequired');
      }
      return true;
    },
    familiaRules() {
      if (this.editedItem.id_familia_atendimento == null || this.editedItem.id_familia_atendimento === '') {
        return this.$t('crudTiposAtendimento.form.validation.familiaRequired');
      }
      return true;
    },
    tipoTicketRules() {
      if (this.editedItem.id_tipo_ticket == null || this.editedItem.id_tipo_ticket === '') {
        return this.$t('crudTiposAtendimento.form.validation.tipoTicketRequired');
      }
      return true;
    },
    populaTiposAtendimento() {
      apiController.request(apiController.endpoints.getallTiposatendimento, {
        onSuccess: (response) => {
          this.tiposAtendimento = response.data;
          this.loadingtable = false;
        },
        onError: () => {
          this.loadingtable = false;
        },
      });
    },
    populaFamiliasAtendimento() {
      apiController.request(apiController.endpoints.getallFamiliasatendimento, {
        onSuccess: (response) => {
          this.familiasAtendimento = response.data || [];
        },
      });
    },
    populaTiposTickets() {
      apiController.request(apiController.endpoints.getallTipostickets, {
        onSuccess: (response) => {
          this.tiposTickets = response.data || [];
        },
      });
    },
    editItem(item) {
      this.editedIndex = this.tiposAtendimento.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.ativo = item.ativo === 1 || item.ativo === true;
      this.editedItem.usa_veiculo = item.usa_veiculo === 1 || item.usa_veiculo === true;
      this.editedItem.usa_equipamento = item.usa_equipamento === 1 || item.usa_equipamento === true;
      this.editedItem.equipamento_por_tipo = item.equipamento_por_tipo === 1 || item.equipamento_por_tipo === true;
      this.editedItem.usa_kit = item.usa_kit === 1 || item.usa_kit === true;
      this.editedItem.kit_por_tipo = item.kit_por_tipo === 1 || item.kit_por_tipo === true;
      this.dialog = true;
    },
    deleteItem(item) {
      this.deletedItem = Object.assign({}, item);
      this.mensagemdialog = this.$t('crudTiposAtendimento.messages.confirmDelete', { nome: item.nome_tipo_atendimento });
      this.showConfirmButton = true;
      this.confirmDialog = true;
    },
    deleteFromDatabase() {
      this.operacao = 2;
      this.confirmDialog = false;
      apiController.request(apiController.endpoints.deleteTipoatendimento, {
        data: { id_tipo_atendimento: this.deletedItem.id_tipo_atendimento },
        onSuccess: (response) => {
          this.updateTable(response.data.erro);
        },
        onError: () => {
          this.loadingtable = false;
        },
      });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.deletedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        if (this.$refs.form) this.$refs.form.resetValidation();
      });
    },
    save() {
      this.$refs.form.validate();
      if (this.formValidado) {
        const payload = {
          id_tipo_atendimento: this.editedItem.id_tipo_atendimento,
          id_familia_atendimento: this.editedItem.id_familia_atendimento,
          id_tipo_ticket: this.editedItem.id_tipo_ticket,
          nome_tipo_atendimento: this.editedItem.nome_tipo_atendimento,
          ativo: this.editedItem.ativo ? 1 : 0,
          usa_veiculo: this.editedItem.usa_veiculo || false,
          usa_equipamento: this.editedItem.usa_equipamento || false,
          equipamento_por_tipo: this.editedItem.equipamento_por_tipo || false,
          usa_kit: this.editedItem.usa_kit || false,
          kit_por_tipo: this.editedItem.kit_por_tipo || false,
        };
        if (this.editedIndex === -1) {
          this.operacao = 0;
          apiController.request(apiController.endpoints.insertTipoatendimento, {
            data: payload,
            onSuccess: (response) => {
              this.updateTable(response.data.erro);
            },
          });
        } else {
          this.operacao = 1;
          apiController.request(apiController.endpoints.updateTipoatendimento, {
            data: payload,
            onSuccess: (response) => {
              this.updateTable(response.data.erro);
            },
          });
        }
      }
    },
    updateTable(status) {
      let mensagem = "";
      const tipo = status ? "error" : "success";

      if (status) {
        if (this.operacao === 0) {
          mensagem = this.$t('crudTiposAtendimento.messages.errorInclusion');
        } else if (this.operacao === 1) {
          mensagem = this.$t('crudTiposAtendimento.messages.errorUpdate');
        } else {
          mensagem = this.$t('crudTiposAtendimento.messages.errorDeletion');
        }
      } else {
        if (this.operacao === 0) {
          mensagem = this.$t('crudTiposAtendimento.messages.includedSuccess');
        } else if (this.operacao === 1) {
          mensagem = this.$t('crudTiposAtendimento.messages.updatedSuccess');
        } else {
          mensagem = this.$t('crudTiposAtendimento.messages.deletedSuccess');
        }
        this.editedItem = Object.assign({}, this.defaultItem);
      }

      EventBus.$emit('show-alert', { mensagem, tipo });
      this.close();
      this.populaTiposAtendimento();
    },
  },
};
</script>
